var Environment = import.meta.env.VITE_ENVIRONMENT;
var Role = import.meta.env.VITE_ROLE;
var AppName = import.meta.env.VITE_APPNAME;
var AppId = import.meta.env.VITE_APPID;
var AppVersion = import.meta.env.VITE_APPVERSION;
var ResourceUrl = import.meta.env.VITE_RESOURCE_URL;
var AppUrl = import.meta.env.VITE_APP_URL;

var DataBase = import.meta.env.VITE_DATABASE;
var Collection = import.meta.env.VITE_COLLECTION;
var partitionKeyHeader = import.meta.env.VITE_PARTITION_KEY_HEADER;

export const Config = {
    Environment,
    Role,
    AppName,
    AppId,
    ResourceUrl,
    AppUrl,
    DataBase,
    Collection,
    partitionKeyHeader,
    AppVersion
}